import { webPuchState, webPuchStateReset } from './webPush.state'
import {
  useApiFirebasePushTokenPost,
  useApiFirebasePushTokenDelete,
} from './api'
import { useWebPushPermission } from './webPushPermission.setup'
import { useWebPushForeground } from './webPushForeground.setup'

export function useWebPush() {
  const {
    webPushPermissionInit,
    webPushPermissionCheck,
    webPushPermissionAsk,
  } = useWebPushPermission()
  const { webPushOnMessage } = useWebPushForeground()

  async function webPushInit(): Promise<void> {
    await webPushPermissionInit()
    webPushPermissionCheck()
    if (webPuchState.token) {
      await useApiFirebasePushTokenPost(webPuchState.token)
    }
  }

  function webPushOn() {
    webPushOnMessage()
  }

  async function webPushPermission(): Promise<boolean> {
    const tokenRes = await webPushPermissionAsk()
    if (tokenRes && webPuchState.token) {
      await useApiFirebasePushTokenPost(webPuchState.token)
    }
    return tokenRes
  }

  async function webPushLogout(): Promise<void> {
    if (!webPuchState.token) return
    await useApiFirebasePushTokenDelete(webPuchState.token)
    webPuchStateReset()
  }

  return {
    webPushInit,
    webPushOn,
    webPushPermission,
    webPushLogout,
  }
}
